<script>
import options from './StafetActions.options'
export default options
</script>

<template>
  <article class="kb-stafet-flow-actions">
    <div class="kb-stafet-flow-actions__buttons-wrapper">

      <button
        v-if="previousStepCallback"
        class="kb-button"
        v-on:click="previousStepCallback"
      >
        {{ previousStepLabel }}
      </button>
  
      <div class="kb-stafet-flow-actions__buttons-right-wrapper">
        <button
          v-if="skipStepCallback"
          class="kb-link kb-stafet-flow-actions__link"
          v-on:click="skipStepCallback"
        >
          {{ skipStepLabel }}
        </button>
    
        <button
          v-if="nextStepCallback"
          class="kb-button kb-button--full-color-spot kb-button--full-color-spot"
          v-on:click="nextStepCallback"
        >
          {{ nextStepLabel }}
        </button> 
      </div>

    </div>

  </article>
</template>
